<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'sectionSelector',
})
</script>
<template>
<a-modal  @ok="submit" v-model:open="opend" width="80%">
  <template #title>
  <a-tabs v-model:activeKey="tabKey" @change="tabChange">
    <a-tab-pane key="default" tab="自定义组件"></a-tab-pane>
    <a-tab-pane key="static" tab="内置组件"></a-tab-pane>
  </a-tabs>
  </template>
  <a-table rowKey="id"  :row-selection="rowselection"  :columns="columns" :dataSource="dataSource" :pagination="pages"  @change="pageChange">
    <template #title>
      <div v-if="rowselection.selectedRowKeys.length>0"  class="flex align-center" style="width: 100%;">
        <span class="text-gray">共选择了<span class="text-primary text-bold padding-lr-sm">{{ rowselection.selectedRowKeys.length }}</span>条数据</span>
      </div>
  </template>
  </a-table>
  </a-modal>
</template>
<script setup name="sectionSelector" lang="ts">
import { onMounted,defineProps,ref,reactive,defineEmits,defineExpose } from 'vue';
import {PlusOutlined} from '@ant-design/icons-vue';
import api from '@/utils/http/service'
import {addip} from '@/utils/util';


const tabKey=ref<String>('default')

const def=ref<Object>({})
const emit=defineEmits(['change'])
const pages=ref<Object>({
  current:1,
  pageSize:10,
  total:0
})
const columns:Array<any>=[
  {title:'编号',dataIndex:'id',width:100},
  {title:'名称',dataIndex:'text'}
]
const rowselection:any=ref({
  fixed:true,
  selectedRowKeys:[],
  onChange:(e:any)=>{
    rowselection.value.selectedRowKeys=e
  }
})
const tabChange=()=>{
    pages.current=1
    pages.total=0
    rowselection.value.selectedRowKeys=[]
    getData()
}
const opend=ref<Boolean>(false)
const dataSource=ref<Array>([])
onMounted(()=>{
  getData()
})
//section={id:,flag:}
const open= (section:Object):void=>{
  if(section){
    def.value=section
  }
  opend.value=true
}
const close= ():void=>{
  opend.value=false
}
const getData= ():void=>{
  if(tabKey.value=='static'){
     api.sitepage.defsections(pages).then(res=>{
      res.data.data.forEach(e=>{
        e.id=e.sub
      })
      dataSource.value=res.data.data
      pages.current=res.data.pageIndex
      pages.pageSize=res.data.pageSize
      pages.total=res.data.records
    })
  }else{
    api.sitepage.sections(pages).then(res=>{

      dataSource.value=res.data.data
      pages.current=res.data.pageIndex
      pages.pageSize=res.data.pageSize
      pages.total=res.data.records
    })
  }
}
const pageChange=(page:Number,pageSize:Number):void=>{
  pages.pageIndex=page
  pages.pageSize=pageSize
  getData()
}
const add=():void=>{
  let len=dataSource.value.length||0
  let v={
    id:0,pageID:props.id,name:'',classname:'default',backgroundimg:'',background:'',orders:len
  }
  dataSource.value.push(v)
}
const submit=():void=>{
  let list= dataSource.value.filter(e=>{
    return rowselection.value.selectedRowKeys.includes(e.id)
  })
  emit('change',list)
  close()
}
defineExpose({
  open,close
})
</script>
